import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { LocaleMessages as messages } from '@/locale'

Vue.use(VueI18n)

// For testing localization, uncomment below and change the default
// locale to 'test':
// messages.test = Object.keys(messages.en)
//   .map(key => ({ [key]: `**${messages.en[key]}**` }))
//   .reduce((acc, val) => ({ ...acc, ...val }), {})

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
})

export default i18n
